import React from "react";
import { EditOutlined } from "@mui/icons-material";
import { Button, Divider } from "@mui/material";
import { Link, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import EnableDisableButton from "components/Shared/EnableDisableButton";
import DeconsolidationBasicDetail from "./DeconsolidationComponents/DeconsolidationBasicDetail";
import BreadcrumbLayout from "layouts/BreadcrumbLayout";

import {
    DeconsolidationDetailContext,
    useDeconsolidationDetailContext,
} from "contexts/DeconsolidationDetailContext";
import {
    useGetDeconsolidationDetailQuery,
    useUpdateDeconsolidationMutation,
} from "store/services/deconsolidationApi";
import DeconsilidationDetailTab from "./DeconsolidationComponents/DeconsilidationDetailTab";
import { useAuth } from "hooks";

const DeconsolidationDetailScreen = () => {
    const { id } = useParams();

    const breadcrumb = [
        { title: "Deconsolidation", path: "/app/crm/deconsolidation/list" },
        { title: "Deconsolidation Detail" },
    ];

    const {
        data: deconsolidationDetail,
        isLoading: loadingDeconsolidation,
        error,
    } = useGetDeconsolidationDetailQuery(id);

    return (
        <DeconsolidationDetailContext.Provider value={{ deconsolidationDetail, loadingDeconsolidation }}>
            <BreadcrumbLayout
                breadcrumbs={breadcrumb}
                isBusy={loadingDeconsolidation}
                headerActions={<PageActions />}
            >
                <BreadcrumbLayout.Error error={error} />
                <BreadcrumbLayout.Paper>
                    <DeconsolidationBasicDetail />
                    <Divider />
                    <DeconsilidationDetailTab />
                </BreadcrumbLayout.Paper>
            </BreadcrumbLayout>
        </DeconsolidationDetailContext.Provider>
    );
};

export default DeconsolidationDetailScreen;

const PageActions = () => {

    const { isAccountAdmin } = useAuth();

    const { deconsolidationDetail, loadingDeconsolidation } = useDeconsolidationDetailContext();

    const [updateDeconsolidation, { isLoading: updatingDeconsolidation }] =
        useUpdateDeconsolidationMutation();

    const handleToggleStatus = async () => {
        try {
            await updateDeconsolidation({
                _id: deconsolidationDetail._id,
                isActive: !deconsolidationDetail.isActive,
            }).unwrap();
            toast.info(`Deconsolidation ${deconsolidationDetail.isActive ? "Disabled" : "Enabled"}!`);
        } catch (error) {
            toast.error(error?.data?.message ?? "Could Not Update Status");
        }
    };


    return (
        <div className="flex space-x-4">
            {isAccountAdmin && (<EnableDisableButton
                isActive={deconsolidationDetail?.isActive}
                loading={loadingDeconsolidation || updatingDeconsolidation}
                onClick={handleToggleStatus}
            />)}
            <Link to={`/app/crm/deconsolidation/${deconsolidationDetail?._id}/edit`}>
                <Button startIcon={<EditOutlined />} variant="contained">
                    Edit
                </Button>
            </Link>
        </div>
    );
};